// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ children, requiredPermission }) {
  const stored = JSON.parse(localStorage.getItem("adminInfo") || "null");

  if (!stored || !stored.token) {
    return <Navigate to="/admin" replace />;
  }

  try {
    const decoded = jwtDecode(stored.token);

    if (decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("adminInfo");
      return <Navigate to="/admin" replace />;
    }

    const user = stored.user;

    if (!user) {
      localStorage.removeItem("adminInfo");
      return <Navigate to="/admin" replace />;
    }

    // SUPER ADMIN FULL ACCESS
    if (user.role === "superAdmin" || user.permissions?.includes("*")) {
      return children;
    }

    // PAGE NEEDS PERMISSION
    if (requiredPermission) {
      if (!user.permissions?.includes(requiredPermission)) {
        return <Navigate to="/admin/panel" replace />;
      }
    }

    return children;
  } catch (err) {
    console.error("ProtectedRoute decode error:", err);
    localStorage.removeItem("adminInfo");
    return <Navigate to="/admin" replace />;
  }
}
